(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      this.setHeaderHeight();

      this.mqlHeaderHeight = window.matchMedia('(max-width: 990px)');
      this.mqlHeaderHeight.addEventListener('change', this.boundSetHeaderHeight);
      window.addEventListener('load', this.boundSetHeaderHeight);

      if (this.header && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
        document.querySelectorAll('.section-header ~ .announcement-bar-section, .section-header ~ .pro-pricing-alert-section').forEach((section) => {
          this.resizeObserver.observe(section);
        });
      }

      document.addEventListener('pro-pricing-alert:visibility', this.boundSetHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      let announcementBarsH = 0;
      document.querySelectorAll('.section-header ~ .announcement-bar-section, .section-header ~ .pro-pricing-alert-section').forEach((section) => {
        announcementBarsH += section.offsetHeight;
      });
      document.documentElement.style.setProperty('--announcement-bars-height', `${announcementBarsH}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.boundSetHeaderHeight);
      if (this.mqlHeaderHeight && this.boundSetHeaderHeight) {
        this.mqlHeaderHeight.removeEventListener('change', this.boundSetHeaderHeight);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      document.removeEventListener('pro-pricing-alert:visibility', this.boundSetHeaderHeight);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-pricing-alert"] && !Shopify.designMode) return;
  try {
    
  class ProPricingAlert extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.pro-pricing-alert-section');
    this.boundUpdate = this.updateVisibility.bind(this);
    this.updateVisibility();

    window.addEventListener('load', this.boundUpdate);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.boundUpdate);
      document.querySelectorAll('.announcement-bar-section').forEach((announcementSection) => {
        this.resizeObserver.observe(announcementSection);
      });
    }

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', this.boundUpdate);
      document.addEventListener('shopify:section:unload', this.boundUpdate);
      document.addEventListener('shopify:section:reorder', this.boundUpdate);
      document.addEventListener('shopify:block:select', this.boundUpdate);
      document.addEventListener('shopify:block:deselect', this.boundUpdate);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.boundUpdate);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.boundUpdate);
      document.removeEventListener('shopify:section:unload', this.boundUpdate);
      document.removeEventListener('shopify:section:reorder', this.boundUpdate);
      document.removeEventListener('shopify:block:select', this.boundUpdate);
      document.removeEventListener('shopify:block:deselect', this.boundUpdate);
    }
  }

  isAnnouncementBarVisible() {
    return Array.from(document.querySelectorAll('.announcement-bar-section')).some((announcementSection) => {
      if (announcementSection.offsetHeight === 0) return false;

      return Array.from(announcementSection.querySelectorAll('.announcement-bar__message span')).some((span) => {
        return span.textContent.trim().length > 0;
      });
    });
  }

  updateVisibility() {
    if (!this.section) return;

    const shouldShow = Shopify.designMode || !this.isAnnouncementBarVisible();
    this.section.classList.toggle('pro-pricing-alert-section--visible', shouldShow);
    this.section.classList.toggle('pro-pricing-alert-section--hidden', !shouldShow);
    document.dispatchEvent(new CustomEvent('pro-pricing-alert:visibility'));
  }
  }

  if (!customElements.get('pro-pricing-alert')) {
    customElements.define('pro-pricing-alert', ProPricingAlert);
  }

  } catch(e) { console.error(e); }
})();
})();
